import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <Box sx={{ py: 8, px: 2, maxWidth: 480, mx: 'auto', textAlign: 'left' }}>
      <Typography variant="h1" sx={{ fontSize: '4rem', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
        403
      </Typography>
      <Typography variant="h5" sx={{ mt: 1, mb: 2, fontWeight: 600 }}>
        Accès interdit
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Votre compte ne permet pas d’ouvrir cette page. Demandez un accès à un administrateur ou continuez depuis l’accueil.
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large" fullWidth sx={{ minHeight: 48, mb: 1.5 }}>
        Retour à l’accueil
      </Button>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Button component={Link} to="/demande-de-reservation" variant="outlined" fullWidth sx={{ minHeight: 44 }}>
          Réserver un créneau
        </Button>
        <Button component={Link} to="/contact" variant="text" fullWidth sx={{ minHeight: 44 }}>
          Me contacter
        </Button>
      </Box>
    </Box>
  );
}
